declare global {
  interface Window {
    Toolkit: {
      new (
        onOpen: (agr1: any, arg2: any) => void,
        onClose: (event: CloseEvent) => void,
        onError: (event: Event) => void,
        options: {
          jnlp_address: string;
          debugEnabled: boolean;
          agent_tls_enabled: boolean;
          agent_host_name: string;
          apiKey?: string;
        }
      ): unknown;
    };
  }
}

import {
  Autocomplete,
  Box,
  Button,
  Card,
  CardContent,
  CircularProgress,
  Collapse,
  // Divider,
  FormControl,
  FormControlLabel,
  IconButton,
  Paper,
  Radio,
  RadioGroup,
  Step,
  StepContent,
  StepLabel,
  Stepper,
  Tab,
  TextField,
  Tooltip,
  Typography,
} from "@mui/material";
import usePopup from "../../../hooks/usePopup";
import { SyntheticEvent, useContext, useEffect, useRef, useState } from "react";
import { assetsUrl, origin } from "../../../constants";
import SettingsIcon from "@mui/icons-material/Settings";
import SettingsInputHdmiIcon from "@mui/icons-material/SettingsInputHdmi";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import DownloadIcon from "@mui/icons-material/Download";
import FolderOpenIcon from "@mui/icons-material/FolderOpen";
import AdminPanelSettingsIcon from "@mui/icons-material/AdminPanelSettings";
import PlayArrowIcon from "@mui/icons-material/PlayArrow";
import CancelIcon from "@mui/icons-material/Cancel";
import {
  formatCardReaderResponse,
  ReaderDataType,
} from "./type/ReaderComponentTypes";
import { RegistrationContext } from "./Registrationform";
import { TabContext, TabList, TabPanel } from "@mui/lab";
// let xmlResponse: any = null;
// let xmlDiv: any = null;
// let fingerData: any = null;
// let verifyxmldata: any = null;
// let self: any = this;
let javaService: any = origin + "/cardReaderConfigurations/";
// let IsNfc: any = false;
// var localAddress: any = window.location.href;
var options = {
  jnlp_address: javaService + "IDCardToolkitService.jnlp",
  debugEnabled: true,
  agent_tls_enabled: false,
  agent_host_name: "toolkitagent.emiratesid.ae",
};

// let IsSam = {
//   sam_secure_messaging: true,
// };

function ReadEid({
  handleData,
}: {
  handleData: (data: ReaderDataType) => void;
}) {
  const { showSnackbar, CustomModal } = usePopup();
  const [value, setValue] = useState("1");
  const [openSettings, setOpenSettings] = useState<boolean>(false);
  const [readerList, setReaderList] = useState<any[]>([]);
  const [expandInfo, setExpandInfo] = useState<boolean>(false);
  const [selectedCard, setSelectedCard] = useState<any>(null);
  const [loading, setLoading] = useState<boolean>(false);
  const [IsSam, setIsSam] = useState<{ sam_secure_messaging: boolean }>({
    sam_secure_messaging: true,
  });
  let readerClass = useRef<any | null>(null);
  let isReaderEnable = useRef<boolean>(false);
  let ToolkitOB = useRef<any | null>(null);
  const { fullReset, setFullReset } = useContext(RegistrationContext);
  const showSuccess = (message: string) => {
    showSnackbar({
      message,
      open: true,
      variant: "success",
      duration: 3000,
    });
  };
  const showInfo = (message: string) => {
    showSnackbar({
      message,
      open: true,
      variant: "info",
      duration: 3000,
    });
  };
  const showError = (message: string) => {
    showSnackbar({
      message,
      open: true,
      variant: "warning",
      duration: 4000,
    });
  };

  var readPublicDataCB = function (response: any, error: any) {
    if (error === null) {
      let cardPublicData = response;
      console.log("Card Public Data: ", cardPublicData);
      const formattedData = formatCardReaderResponse(cardPublicData);
      handleData(formattedData);
      setLoading(false);
    } else {
      // console.log("readPublicDataCB => ", error);
      setLoading(false);
      showError(error.message);
    }
  };

  const generateRequestId = (len: number): string => {
    var text = "";
    var possible =
      "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
    for (var i = 0; i < len; i++) {
      text += possible.charAt(Math.floor(Math.random() * possible.length));
    }
    return btoa(text);
  };

  const readPublicData = async () => {
    const requestId = generateRequestId(40);
    console.log("Request ID generated: ", requestId.length, requestId);
    setLoading(true);
    readerClass.current.readPublicData(
      requestId,
      true,
      true,
      true,
      true,
      true,
      readPublicDataCB
    );
  };

  var connectReaderCB = function (response: any, error: any) {
    if (null != response) {
      isReaderEnable.current && showSuccess("Connected to the reader");
      // console.log("connectReaderCB response => ", response);
      readerClass.current.getInterfaceType((response: any, error: any) => {
        if (null !== error) {
          setLoading(false);
          showError(error.code + " : " + error.message);
          ToolkitOB.current = null;
          return;
        }
        if (response === 2) {
          console.log("Initialize Success. First Set NFC Parameters.");
        } else {
          // console.log("Initialize Success. First Set Smart Card Parameters.");
          if (isReaderEnable.current) {
            readPublicData();
          }
        }
      });
    }
    if (null != error) {
      // console.log("connectReaderCB error => ", error);
      setLoading(false);
      showError(error.message);
      ToolkitOB.current = null;
      return error.code + " : " + error.message;
    }
  };

  var listReaderCB = function (response: any, error: any) {
    let readerList = response;
    if (Boolean(error)) {
      // console.log("listReaderCB error => ", error);
      setLoading(false);
      ToolkitOB.current = null;
      isReaderEnable.current && showError(error?.message || "No readers found");
    } else {
      if (IsSam.sam_secure_messaging) {
        readerClass.current = readerList;
      } else {
        readerClass.current = readerList[0];
        setSelectedCard(readerList[0]);
        setReaderList(readerList);
      }
      readerClass.current.connect(connectReaderCB);
    }
  };

  let onOpenHandlerCB = function (_: any, error: any) {
    if (error === null) {
      console.log("onOpenHandlerCB success =>");
      if (IsSam.sam_secure_messaging) {
        ToolkitOB.current.getReaderWithEmiratesId(listReaderCB);
      } else {
        ToolkitOB.current.listReaders(listReaderCB);
      }
    } else {
      ToolkitOB.current = null;
      setLoading(false);
      showError(error.message);
      // console.log("onOpenHandlerCB error =>", error.message);
    }
  };

  var errorHandlerCB = function (err: any) {
    readerClass.current = null;
    ToolkitOB.current = null;
    setLoading(false);
    if (null !== err) {
      // console.log("errorHandlerCB error =>", err);
      showError("ERROR : " + err);
    }
  };

  var closeHandlerCB = function (_: any) {
    ToolkitOB.current = null;
    readerClass.current = null;
    setLoading(false);
  };

  const initializeReader = () => {
    ToolkitOB.current = null;
    readerClass.current = null
    console.log("--------------Ready to initialize--------------")
    setSelectedCard(null);
    try {
      if (ToolkitOB.current !== null) {
        if (readerClass.current !== null) {
          showInfo("WebSocket is already active ...");
        }
      } else {
        ToolkitOB.current = new window.Toolkit(
          onOpenHandlerCB /* reference to onOpen call back function */,
          closeHandlerCB /* reference to onClose call back function */,
          errorHandlerCB /* reference to onError call back function */,
          options /* options */
        );
      }
    } catch (e: any) {
      // console.log("reader error => ", e);
      setLoading(false);
      showError("ERROR : " + e.message);
    }
  };

  const readEid = async () => {
    initializeReader();
    isReaderEnable.current = true;
    setLoading(true);
  };

  let disconnectCB = function (_: any, error: any) {
    if (error !== null) {
      return;
    } else {
      ToolkitOB.current = null;
      readerClass.current = null;
      isReaderEnable.current && showSuccess("Disconnected");
      isReaderEnable.current = false;
    }
  };

  const handleOpen = () => {
    setOpenSettings(true);
    setReaderList([]);
  };
  const handleCardSelect = (_: SyntheticEvent, value: any) => {
    setSelectedCard(value);
    readerClass.current = value || null;
  };

  const handleOpenInfo = () => setExpandInfo((prev) => !prev);

  const resetCardReader = () => {
    console.log("resetCardReader called ")
    setLoading(false);
    if(Boolean(readerClass.current)){
      readerClass.current?.disconnect(disconnectCB);
    }else{
      disconnectCB(null,null)
    }
    ToolkitOB.current = null;
    readerClass.current = null;
    setFullReset(false);
  };

  const handleChange = (_: React.SyntheticEvent, newValue: string) => {
    setValue(newValue);
  };

  useEffect(() => {
    initializeReader();
    return () => {
      if (readerClass.current) {
        console.log("inside return");
        readerClass.current.disconnect(disconnectCB);
        setSelectedCard(null);
        setReaderList([]);
      }
    };
  }, []);

  useEffect(() => {
    if (fullReset && isReaderEnable.current) {
      resetCardReader();
      console.log("Resetting card reader");
    }
  }, [fullReset]);

  return (
    <>
      <CustomModal
        title="Card reader settings"
        open={openSettings}
        setOpen={setOpenSettings}
        handleClose={setOpenSettings}
      >
        <div className="w-[30vw] h-fit max-h-[70dvh]">
          <div className="grid grid-cols-4 gap-2 p-2">
            <div className="col-span-2">
              <FormControl>
                <RadioGroup
                  aria-labelledby="demo-radio-buttons-group-label"
                  defaultValue={
                    IsSam.sam_secure_messaging ? "Method 1" : "Method 2"
                  }
                  name="radio-buttons-group"
                  row={true}
                  onChange={(e) => {
                    setIsSam({
                      sam_secure_messaging: e.target.value === "Method 1",
                    });
                  }}
                >
                  <FormControlLabel
                    value={"Method 1"}
                    control={<Radio />}
                    label="Method 1"
                  />
                  <FormControlLabel
                    value={"Method 2"}
                    control={<Radio />}
                    label="Method 2"
                  />
                </RadioGroup>
              </FormControl>
            </div>
            <div></div>
            <div className="flex items-center justify-end gap-2">
              {!IsSam.sam_secure_messaging && (
                <Button
                  onClick={initializeReader}
                  endIcon={<SettingsInputHdmiIcon />}
                >
                  initialize
                </Button>
              )}
              <Tooltip title="Reader services settings steps">
                <IconButton color="info" onClick={handleOpenInfo}>
                  <InfoOutlinedIcon />
                </IconButton>
              </Tooltip>
            </div>
          </div>
          <div className="py-3 px-2 flex gap-2">
            {!IsSam.sam_secure_messaging && (
              <Autocomplete
                fullWidth
                value={selectedCard}
                options={readerList || []}
                getOptionLabel={(option) => option.readerName}
                onChange={handleCardSelect}
                renderInput={(params) => (
                  <TextField {...params} label="Select reader" />
                )}
              />
            )}
            {/* <div className="flex justify-start items-center">
                <Button color="success" onClick={connectReader}>connect</Button>
              </div> */}
          </div>
          <div className="p-2 max-h-[40dvh] overflow-y-auto">
            <Collapse in={expandInfo} timeout="auto" unmountOnExit>
              <Card elevation={0} sx={{ margin: "auto" }}>
                <CardContent>
                  <Typography variant="h6" gutterBottom>
                    Card Reader Guide
                  </Typography>
                  {/* <Divider sx={{ mb: 2, width: "100%" }} /> */}

                  <TabContext value={value}>
                    <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
                      <TabList
                        onChange={handleChange}
                        aria-label="lab API tabs example"
                        variant="fullWidth"
                      >
                        <Tab label="Configuring services" value="1" />
                        <Tab label="Read data" value="2" />
                      </TabList>
                    </Box>
                    <TabPanel value="1">
                      <Stepper orientation="vertical">
                        <Step active>
                          <StepLabel>Download EXE file</StepLabel>
                          <StepContent>
                            <Box display="flex" alignItems="center" mb={2}>
                              <DownloadIcon color="primary" sx={{ mr: 2 }} />
                              <Box>
                                <Typography variant="body2">
                                  Download the EXE file by clicking the download
                                  button.
                                </Typography>
                                <Button
                                  component="a"
                                  variant="outlined"
                                  size="small"
                                  href={`${assetsUrl}/configfiles/PappyJoeCardReader.exe`}
                                  startIcon={<DownloadIcon />}
                                  download="PappyJoeCardReader.exe"
                                  sx={{ mt: 1 }}
                                  target="_blank"
                                  rel="noopener noreferrer"
                                >
                                  Download
                                </Button>
                              </Box>
                            </Box>
                          </StepContent>
                        </Step>

                        <Step active>
                          <StepLabel>Run the EXE file</StepLabel>
                          <StepContent>
                            <Box display="flex" alignItems="center" mb={2}>
                              <AdminPanelSettingsIcon
                                color="secondary"
                                sx={{ mr: 2 }}
                              />
                              <Box>
                                <Typography variant="body2">
                                  Double-click to run the downloaded EXE file.
                                  <br />
                                  <strong>Optional:</strong> Right-click and
                                  select <strong>"Run as administrator"</strong>{" "}
                                  for best results.
                                </Typography>
                              </Box>
                            </Box>
                          </StepContent>
                        </Step>

                        <Step active>
                          <StepLabel>Search Application</StepLabel>
                          <StepContent>
                            <Box display="flex" alignItems="center" mb={2}>
                              <FolderOpenIcon color="info" sx={{ mr: 2 }} />
                              <Box>
                                <Typography variant="body2">
                                  Search <strong>PappyJoe Card Reader</strong>{" "}
                                  in the Windows search bar.
                                </Typography>
                              </Box>
                            </Box>
                          </StepContent>
                        </Step>

                        <Step active>
                          <StepLabel>
                            Run the Application as Administrator
                          </StepLabel>
                          <StepContent>
                            <Box display="flex" alignItems="center" mb={2}>
                              <AdminPanelSettingsIcon
                                color="secondary"
                                sx={{ mr: 2 }}
                              />
                              <Box>
                                <Typography variant="body2">
                                  Right-click the application and choose{" "}
                                  <strong>"Run as administrator"</strong>.
                                </Typography>
                              </Box>
                            </Box>
                          </StepContent>
                        </Step>

                        <Step active>
                          <StepLabel>Click Config</StepLabel>
                          <StepContent>
                            <Box display="flex" alignItems="center" mb={2}>
                              <PlayArrowIcon color="primary" sx={{ mr: 2 }} />
                              <Box>
                                <Typography variant="body2">
                                  In the app, click the <strong>Config</strong>{" "}
                                  button to configure the card reader.
                                </Typography>
                              </Box>
                            </Box>
                          </StepContent>
                        </Step>

                        <Step active>
                          <StepLabel>Start the Application</StepLabel>
                          <StepContent>
                            <Box display="flex" alignItems="center">
                              <PlayArrowIcon color="success" sx={{ mr: 2 }} />
                              <Box>
                                <Typography variant="body2">
                                  After successful configuration, click the{" "}
                                  <strong>Start</strong> button to begin using
                                  the card reader.
                                </Typography>
                              </Box>
                            </Box>
                          </StepContent>
                        </Step>
                      </Stepper>
                    </TabPanel>
                    <TabPanel value="2">
                      <Stepper orientation="vertical">
                        <Step active>
                          <StepLabel>Read Data from the Card</StepLabel>
                          <StepContent>
                            <Box mb={2}>
                              <Typography variant="body2" gutterBottom>
                                After starting the services, you can read data
                                from the card using two methods:
                              </Typography>
                              <Typography variant="body2" sx={{ ml: 2 }}>
                                <strong>1. First method:</strong> Read from the
                                default connected reader by clicking the{" "}
                                <Button className="cursor-default">
                                  READ EID
                                </Button>{" "}
                                button.
                              </Typography>
                              <Typography variant="body2" sx={{ ml: 2 }}>
                                <strong>2. Second method:</strong> If multiple
                                readers are connected, select the desired reader
                                from the dropdown.
                                <em>
                                  {" "}
                                  (Note: The first method is not working, please
                                  use this method.)
                                </em>
                              </Typography>
                            </Box>
                          </StepContent>
                        </Step>
                        <Step active>
                          <StepLabel>Reset Before Next Card</StepLabel>
                          <StepContent>
                            <Typography variant="body2">
                              After reading the data, it is{" "}
                              <strong>mandatory</strong> to click the{" "}
                              <Button color="error">RESET</Button> button at the
                              bottom right corner before reading the next card.
                            </Typography>
                          </StepContent>
                        </Step>
                      </Stepper>
                    </TabPanel>
                  </TabContext>
                </CardContent>
              </Card>
            </Collapse>
          </div>
        </div>
      </CustomModal>
      <Paper className="flex items-center gap-2 rounded py-1 px-2">
        <Button
          disabled={loading}
          endIcon={loading && <CircularProgress size={20} />}
          onClick={readEid}
        >
          read eid
        </Button>

        {loading && (
          <Tooltip title="Cancel">
            <IconButton color="error" onClick={resetCardReader}>
              <CancelIcon />
            </IconButton>
          </Tooltip>
        )}

        <Tooltip title="Card reader settings">
          <IconButton color="primary" onClick={handleOpen}>
            <SettingsIcon />
          </IconButton>
        </Tooltip>
      </Paper>
    </>
  );
}

export default ReadEid;
